/** Утилита для управления видимостью элемента */

export const utilEventElementVisibility = {
  show: (eventName: string) => {
    window.dispatchEvent(new CustomEvent(eventName));
  },

  hide: (eventName: string) => {
    window.dispatchEvent(new CustomEvent(eventName));
  },

  onShow: (eventName: string, callback: () => void) => {
    const handler = () => callback();
    window.addEventListener(eventName, handler);

    return () => {
      window.removeEventListener(eventName, handler);
    };
  },

  onHide: (eventName: string, callback: () => void) => {
    const handler = () => callback();
    window.addEventListener(eventName, handler);

    return () => {
      window.removeEventListener(eventName, handler);
    };
  }
};
